import  React from "react";
import PropTypes from "prop-types";

export default class Gate extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    placeholder: PropTypes.node
  }
  static defaultProps = {
    placeholder: null
  }
  render() {
    if (this.props.isOpen) {
      return this.props.children;
    } else {
      return this.props.placeholder;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Gate.js